import classNames from "classnames";
import { memo, forwardRef, createElement } from "react";
import { useClassNamePrefix } from "../../auxiliary/useClassNamePrefix.js";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
const Heading = memo(
  forwardRef(
    ({ children, className, distinction, depth, size, ...headingProps }, ref) => {
      const prefix = useClassNamePrefix();
      const normalizedDepth = depth ?? 6;
      const headingElement = `h${normalizedDepth}`;
      return createElement(
        headingElement,
        {
          ref,
          className: classNames(`${prefix}heading`, className, toEnumViewClass(size), toEnumViewClass(distinction)),
          ...headingProps
        },
        children
      );
    }
  )
);
Heading.displayName = "Heading";
export {
  Heading
};
//# sourceMappingURL=Heading.js.map
